/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ModalController } from '@ionic/angular';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss']
})
export class ModalConfirmationComponent {
  @Input() title: string;

  @Input() question: string;

  @Input() confirmText?: string;

  @Input() cancelText?: string;

  constructor(private modalController: ModalController) {}

  confirm(): void {
    this.closeModal(true);
  }

  reject(): void {
    this.closeModal(false);
  }

  private async closeModal(rejected: boolean): Promise<void> {
    await this.modalController.dismiss(rejected);
  }
}
